<div class="sx-contract__table metering-point-item__functioncontrol-list" id="function_control_table_view">
  <mat-table #table [dataSource]="dataSource" matSort aria-label="Elements" [matSortActive]="sortActive"
  [matSortDirection]="sortDirection">

  <ng-container matColumnDef="id">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'metering.item.functioncontrol.id' | translate}}</mat-header-cell>
    <mat-cell *matCellDef="let row">
      <span class="mobile-label">{{'metering.item.functioncontrol.id' | translate}}:</span>
      <div class="sx-invoices__report-wrapper">
        <a href="javascript:void(0)"
          (click)="getReportKey(row.id)" class="metering-point-item__link"><span><svg class="metering-point-item__icon">
            <use xlink:href="#sx-pdf" href="#sx-pdf" />
          </svg></span><span>{{row.id}}</span>
        </a>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="performed">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'metering.item.functioncontrol.performed' | translate}}
    </mat-header-cell>
    <mat-cell *matCellDef="let row">
      <span class="mobile-label">{{'metering.item.functioncontrol.performed' | translate}}:</span>
      <span>{{row.performed}}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="notes">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'metering.item.functioncontrol.notes' | translate}}
    </mat-header-cell>
    <mat-cell *matCellDef="let row">
      <span class="mobile-label">{{'metering.item.functioncontrol.notes' | translate}}:</span>
      <span *ngIf="row.notes" [innerHTML]="row.notes"></span>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>

  <mat-paginator #paginator [length]="dataSource.data.length" (page)="onPagination($event)"  [pageIndex]="currentPage" [pageSize]="pageSize"
    [pageSizeOptions]="[10, 25, 50, 100, 250]">
  </mat-paginator>
</div>

<div *ngIf="!functionControls">
  <app-spinner text="{{'metering.item.functioncontrol.getting'|translate}}"></app-spinner>
</div>

<div *ngIf="functionControls && functionControls.length === 0">
  <app-no-content [displayText]="'metering.item.functioncontrol.no-items'|translate"></app-no-content>
</div>

